module.exports = __webpack_public_path__ + "static/media/dashconcept.7373e858.svg";